import React, { useState } from "react";
import { HelpBlock } from "react-bootstrap";
import {
  BadgeDeleteBtn,
  InputBadgeCover,
  InputBadgeText,
  InputBadgeWrapper,
  Label,
  TextBadge,
} from "./const";

export const MultipleInput = ({
  field: { name },
  label = "",
  onChange = () => {
    //
  },
  onDelete = () => {
    //
  },
  style = {},
  placeholder = "Select...",
  tags = [],
  onKeysDownActions = ["Enter", "Tab"],
  showError = true,
  form: { errors, touched },
  showInput = true,
  errorContainerClass = "",
  isDisabled = false,
}) => {
  const [inputValue, setInputValue] = useState("");

  const handleKeyDown = (event) => {
    event.target.style.height = "inherit";
    event.target.style.height = `${event.target.scrollHeight}px`;
    event.target.style.overflow = "hidden";

    if (!inputValue) return;

    if (onKeysDownActions.includes(event.key)) {
      event.preventDefault();
      onChange(inputValue);
      setInputValue("");
    }
  };
  return (
    <div className="row">
      <div className="col-lg-12">
        {label && <Label>{label}</Label>}
        <InputBadgeWrapper style={{ ...style }}>
          <InputBadgeCover>
            {tags?.length > 0 &&
              tags.map((tag) => (
                <TextBadge>
                  {tag}
                  {!isDisabled ? (
                    <BadgeDeleteBtn
                      role="img"
                      onClick={() => {
                        onDelete(tag);
                      }}
                    >
                      <svg
                        viewBox="64 64 896 896"
                        focusable="false"
                        data-icon="close"
                        width="17px"
                        height="17px"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"></path>
                      </svg>
                    </BadgeDeleteBtn>
                  ) : null}
                </TextBadge>
              ))}
            {showInput && (
              <InputBadgeText
                name={name}
                value={inputValue}
                disabled={isDisabled}
                onKeyDown={handleKeyDown}
                onBlur={(e) => {
                  if (!inputValue) return;
                  onChange(inputValue);
                  setInputValue("");
                }}
                onChange={(e) => {
                  setInputValue(e.target.value);
                }}
                placeholder={
                  (tags === null || tags.length === 0) && placeholder
                }
              />
            )}

            {/* <InputFieldLoader isLoading={isDisabled} /> */}
          </InputBadgeCover>
        </InputBadgeWrapper>
      </div>
      <div className={errorContainerClass} style={{ marginLeft: "20px" }}>
        {showError && <HelpBlock>{touched[name] && errors[name]}</HelpBlock>}
      </div>
    </div>
  );
};
